export default "__VITE_ASSET__DsuV03Cz__"